module.exports = __webpack_public_path__ + "img/avatar04.f2dd2573.png";